/*
 * Bisou Rivage — Ventes & fidélité (version ALT, 14/10/2026)
 * Module autonome. Ne modifie aucune logique du thème : il ajoute des éléments
 * et, pour la barre d'achat, déclenche le vrai bouton « Ajouter au panier ».
 * Réglages : section « Ventes & fidélité (ALT) » dans le pied de page.
 */
(function () {
  'use strict';

  var cfgEl = document.getElementById('bvf-config');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var F = CFG.features || {};
  var root = document.documentElement;

  /* ---------- Outils ---------- */
  function storeGet(key, session) {
    try { return (session ? window.sessionStorage : window.localStorage).getItem(key); } catch (e) { return null; }
  }
  function storeSet(key, value, session) {
    try { (session ? window.sessionStorage : window.localStorage).setItem(key, value); } catch (e) { /* stockage indisponible */ }
  }
  function debounce(fn, wait) {
    var t;
    return function () { clearTimeout(t); t = setTimeout(fn, wait); };
  }
  /* Le panier tel que l'annonce l'événement « cart-update », sans attendre /cart.js : le panier entier (+, −, retirer)
     ou la ligne ajoutée (fiche), fondue dans le dernier panier connu. L'appel à /cart.js qui suit corrige tout écart.
     Sert à peindre la jauge et les paliers dans le même temps que le tiroir, au lieu de les faire surgir après.
     Aussi sur la page panier depuis le 25/10 (tiroir 5) : son total ne se réécrit plus en deux temps. */
  function cartFromEvent(ev, last) {
    var c = ev && ev.cartData;
    if (!c || c.status) return null;
    if (Array.isArray(c.items) && c.item_count != null) return c;
    if (!last || !c.key || c.quantity == null) return null;
    var items = (last.items || []).slice(), at = -1, same = 0, i;
    var variant = String(c.key).split(':')[0];
    for (i = 0; i < items.length; i++) {
      if (items[i].key === c.key) { at = i; same = 1; break; }
      if (String(items[i].key).split(':')[0] === variant) { at = i; same++; }
    }
    if (at >= 0 && same === 1) items[at] = c; else items.unshift(c);
    var count = 0;
    items.forEach(function (it) { count += it.quantity || 0; });
    var out = {};
    for (i in last) { if (Object.prototype.hasOwnProperty.call(last, i)) out[i] = last[i]; }
    out.items = items; out.item_count = count;
    return out;
  }
  function money(cents) {
    cents = Math.max(0, Math.round(cents || 0));
    var cur = CFG.currency || 'EUR';
    if (cur !== 'EUR') {
      /* 28/10 (c28b-prix-devise-fiche) : écrit comme les cartes de la boutique (« ¥17,100 »), pas « 17 100 JPY » en français */
      try { return new Intl.NumberFormat('en', { style: 'currency', currency: cur }).format(cents / 100); } catch (e) { /* repli */ }
    }
    var whole = Math.floor(cents / 100);
    var rest = cents % 100;
    var txt = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    if (rest) txt += ',' + (rest < 10 ? '0' : '') + rest;
    return txt + ' €';
  }
  function isOff() { return root.classList.contains('bvf-off'); }
  /* Les liens écrits ici gardent la langue de la page (« /en/… ») — 25/10, chaîne site-anglais */
  function loc(u) {
    u = String(u || '');
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (r === '/' || u.charAt(0) !== '/' || u.indexOf(r) === 0) return u;
    return r.replace(/\/$/, '') + u;
  }
  /* Noms de cadre des variantes et propriété « Composition » (« diptyque (2 cadres) »), écrits en français dans Shopify
     et dans la commande : à l'écran seulement, ceux que donne le pont (anglais) */
  /* Type « tirage » : en anglais Shopify le traduit (« Fine art print ») ; le pont donne aussi le type d'origine */
  function isPrintType(t) {
    var a = String(CFG.printType || ''), b = String(CFG.printTypeAlt || ''); t = String(t || '');
    return !a || t === a || (!!b && t === b);
  }
  function frameName(v) {
    var s = String(v), m = CFG.frames || {}, c = CFG.compo || {};
    if (m[s.toLowerCase()]) return m[s.toLowerCase()];
    var x = /^(\S+) \((\d+) cadres?\)$/.exec(s);
    if (x && c[x[1].toLowerCase()] && c.n) return c[x[1].toLowerCase()] + (c.open || ' (') + String(x[2] === '1' && c.one ? c.one : c.n).replace('[n]', x[2]) + (c.close || ')');
    return v;
  }
  function safe(fn) { try { fn(); } catch (e) { if (window.console) console.warn('[bvf]', e); } }

  /* ---------- Avant / après ---------- */
  var isPreview = !!(window.Shopify && ((window.Shopify.theme && window.Shopify.theme.role && window.Shopify.theme.role !== 'main') || window.Shopify.designMode));
  var refreshers = [];
  /* Prêtés par le bloc 6 (prix à la française) au bloc 8 (panier), qui les applique sans attendre (25/10, tiroir 5) */
  var frPrice = null, frWalk = null;
  function refreshAll() { refreshers.forEach(function (fn) { safe(fn); }); }

  /* 29/10 (c29t-retirer-outils-apercu) : la pastille Avant / Après et ?bvf=off sont retirés avant la mise en ligne
     (?bvf=off passait aussi sur le site publié). Un onglet resté sur « Avant » revient à la version du site. */
  safe(function () { storeSet('bvf_off', '0', true); });

  /* En aperçu, la barre Shopify du bas passe au-dessus de tout : on remonte nos éléments d'autant */
  safe(function () {
    if (!isPreview) return;
    function lever() {
      var w = document.getElementById('PBarNextFrameWrapper');
      var lift = 0;
      if (w) {
        var r = w.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        if (r.height && r.top < vh) lift = Math.round(vh - r.top);
      }
      var bar = document.getElementById('bvf-sticky');
      if (bar) bar.style.bottom = lift ? lift + 'px' : '';
      var card = document.getElementById('bvf-nl');
      if (card) card.style.marginBottom = lift ? lift + 'px' : '';
      /* La pastille : au-dessus de la barre Shopify (qui passe devant tout) et de la ligne qui dépasse sous
         la photo d'accueil, puis au-dessus de la barre d'achat ou de la carte lettre si elles sont dessous */
      var box = document.querySelector('.bvf-pastille');
      if (box) {
        var h = window.innerHeight || document.documentElement.clientHeight;
        var b = box.getBoundingClientRect();
        var low = lift ? lift + 32 : 0;
        /* 23/10 (v7-23) : au téléphone, la place de la barre d'achat reste gardée, qu'elle soit montrée ou
           non. La pastille suivait la barre une fois par seconde et cachait « Choisir » pendant qu'elle
           remontait (au chargement, puis à chaque retour de la barre). Elle ne bouge plus. */
        if (bar && !bar.hidden && bar.offsetHeight && window.matchMedia('(max-width: 749px)').matches) {
          low = Math.max(low, lift + bar.offsetHeight - 8);
        }
        [card].forEach(function (el) {
          if (!el || el.hidden) return;
          if (!el.classList.contains('is-open')) return;
          var q = el.getBoundingClientRect();
          if (q.right <= b.left || q.left >= b.right || q.top >= h) return;
          low = Math.max(low, Math.round(h - q.top) - 8);
        });
        box.style.marginBottom = low > 0 ? low + 'px' : '';
      }
    }
    lever();
    setInterval(lever, 1000);
  });

  /* ---------- 1. Fiche produit : confiance et livraison ---------- */
  safe(function () {
    if (!F.trust || CFG.template !== 'product' || !CFG.trustEligible) return;
    var tpl = document.getElementById('bvf-tpl-trust');
    if (!tpl || !tpl.content || !tpl.content.firstElementChild) return;

    function anchorEl() {
      var a = document.querySelector('.bisou-buy-row');
      if (!a) {
        var btn = document.querySelector('product-form .product-form__submit');
        a = btn ? btn.closest('product-form') : null;
      }
      return a && a.parentNode ? a : null;
    }
    /* La colonne produit est rangée avec « order » (flex) : le bloc prend le même rang que le bouton d'achat */
    function syncOrder() {
      var node = document.querySelector('[data-bvf="trust"]');
      var a = anchorEl();
      if (node && a) node.style.order = window.getComputedStyle(a).order || '';
    }
    function place() {
      if (!document.querySelector('[data-bvf="trust"]')) {
        var a = anchorEl();
        if (!a) return;
        a.parentNode.insertBefore(tpl.content.firstElementChild.cloneNode(true), a.nextSibling);
      }
      syncOrder();
    }
    place();
    window.addEventListener('resize', debounce(syncOrder, 150));
    var host = document.querySelector('.product__info-container') || document.querySelector('main');
    if (host && window.MutationObserver) {
      new MutationObserver(debounce(function () {
        if (!document.querySelector('[data-bvf="trust"]')) place();
      }, 200)).observe(host, { childList: true, subtree: true });
    }
  });

  /* ---------- 2. Barre d'achat fixe sur téléphone ---------- */
  safe(function () {
    if (!F.sticky || CFG.template !== 'product') return;
    var bar = document.getElementById('bvf-sticky');
    if (!bar) return;
    var mq = window.matchMedia('(max-width: 749px)');
    var mainBtn = null;
    var mode = 'hidden';

    function findBtn() {
      var b = document.querySelector('product-form .product-form__submit[name="add"]') ||
        document.querySelector('product-form [type="submit"]');
      return b && b.isConnected ? b : null;
    }
    mainBtn = findBtn();
    if (!mainBtn) return;

    document.body.appendChild(bar);
    var titleEl = bar.querySelector('[data-bvf-sticky-title]');
    var priceEl = bar.querySelector('[data-bvf-sticky-price]');
    var actionBtn = bar.querySelector('[data-bvf-sticky-action]');
    var h1 = document.querySelector('main h1') || document.querySelector('h1');
    titleEl.textContent = ((h1 && h1.innerText) || document.title).replace(/\s+/g, ' ').trim();

    function currentPrice() {
      var lines = (mainBtn.innerText || '').split('\n').map(function (s) { return s.trim(); }).filter(Boolean);
      for (var i = lines.length - 1; i >= 0; i--) {
        /* ¥ : sans lui, la barre restait sur « À partir de ¥6,300 » en région Japon (relecture c28b, 28/10) */
        if (/\d/.test(lines[i]) && /€|EUR|\$|£|¥|JPY|CHF/.test(lines[i])) return lines[i];
      }
      return '';
    }
    function chooseLabel() {
      var s = CFG.sticky || {};
      if (CFG.suffix === 'tshirt' && s.chooseSize) return s.chooseSize;
      if (!CFG.trustEligible && s.chooseOther) return s.chooseOther;
      return s.choose;
    }
    /* Même texte que le vrai bouton (« Ajouter au panier », « Précommander », « Épuisé »…) */
    function addLabel() {
      var first = (mainBtn.innerText || '').split('\n')[0].trim();
      return first || CFG.sticky.add;
    }
    function fromLabel() {
      var tplTxt = (CFG.product && CFG.product.fromLabel) || '';
      var min = CFG.product && CFG.product.priceMin;
      if (!min) return '';
      return tplTxt.indexOf('[prix]') !== -1 ? tplTxt.replace('[prix]', money(min)) : money(min);
    }
    /* Le prix dit ce qu'il paie : « A4 encadré · 55 € », le même avant et après
       le bouton. La barre disait « À partir de 35 € » puis « 55 € » sans dire
       pourquoi (fiche parcours-selecteur-a, 21/10). L'état vient du sélecteur
       des tirages (window.__bisouState, assets/bisou-variant-ui.js) ; sans lui
       (t-shirt), la barre garde ses anciens textes. */
    function choicePrice() {
      var st = window.__bisouState;
      if (CFG.suffix === 'tshirt' || !st || !/^A[234]$/.test(st.format || '')) return '';
      var p = currentPrice();
      var s = CFG.sticky || {};
      return p ? st.format + ' ' + (st.withFrame ? (s.framed || 'encadré') : (s.unframed || 'sans cadre')) + ' · ' + p : '';
    }
    /* Le visiteur a choisi un format, un cadre ou une couleur : la barre ajoute
       ce qu'elle affiche (« A4 sans cadre · 35 € ») au lieu de redemander
       « Choisir mon format » et de remonter vers des formats déjà à l'écran
       (amélioration continue, fiche tirage verticale, 24/10). `[data-f]` : les
       lignes « Tirage Express » et « Précommande » du t-shirt portent aussi
       `.rv5-format-row` sans être une taille (reprise barre t-shirt, 24/10). */
    var chosen = false;
    document.addEventListener('click', function (e) {
      if (chosen || !e.target || !e.target.closest) return;
      if (!e.target.closest('.rv5-format-row[data-f], .rv5-btn-sans, .rv5-btn-avec, .rv5-color-swatch')) return;
      chosen = true;
      render();
    }, true);
    /* Un tirage arrive avec un format déjà choisi (A3 encadré), que la barre
       nomme : elle l'ajoute dès l'arrivée au lieu de dire « Choisir mon format »
       au-dessus des formats déjà à l'écran (perfection site-vendeur, 25/10).
       Format épuisé à l'arrivée : elle garde « Choisir mon format ». L'épuisé
       se lit au texte du vrai bouton (« Épuisé », « Non disponible ») : Dawn le
       grise aussi le temps de recharger la section ou d'ajouter, et la barre
       clignotait « Choisir mon format » (reprise, 25/10). */
    function soldOut() {
      var s = window.variantStrings || {};
      var span = mainBtn.querySelector('span');
      var t = ((span || mainBtn).textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      return !!t && [s.soldOut, s.unavailable].some(function (x) { return x && t === String(x).trim().toLowerCase(); });
    }
    function busy() { return !!(mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true'); }
    function ready() { return !soldOut() && !!choicePrice(); }
    function adding() { return mode === 'add' || (mode === 'choose' && (chosen || ready())); }
    /* Un toucher pendant que le vrai bouton est grisé : l'ajout part dès qu'il revient */
    var pending = false;
    function render() {
      var show = mq.matches && mode !== 'hidden' && !isOff();
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', String(!show));
      root.classList.toggle('bvf-sticky-on', show);
      /* Cachée au téléphone, elle garde ses mots : elle passait sur « Choisir mon format » le temps de glisser
         hors de l'écran (relecture c29t-fiche-achat-rapide, 29/10). À l'ordinateur, elle reste tenue à jour :
         la barre de rappel (bisou-rappel-panier.js) y lit « A3 encadré · 95 € ». */
      if (!show && mq.matches) return;
      if (adding()) {
        priceEl.textContent = choicePrice() || currentPrice();
        /* Avant tout geste, le gris passager de Dawn ne grise pas la barre */
        actionBtn.disabled = busy() && (chosen || mode === 'add');
        actionBtn.textContent = addLabel();
      } else {
        priceEl.textContent = choicePrice() || fromLabel();
        actionBtn.disabled = false;
        actionBtn.textContent = chooseLabel();
      }
    }

    /* Position du vrai bouton : au-dessus de l'écran = « ajouter », visible ou encore dessous = barre cachée.
       La barre attend que le vrai bouton soit passé : elle s'affichait dès l'arrivée (« choisir ») et
       couvrait la rangée des cadres (c29t-fiche-achat-rapide, 29/10). */
    /* Les boutons d'Associez-le (.bvf-assoc__actions) : la barre s'efface quand ils arrivent à 200 px sous le
       bas de l'écran et ne revient qu'une fois qu'ils sont sortis par le haut, comme le rappel de l'ordinateur
       (assets/bisou-rappel-panier.js, c29, 29/10). */
    function assocNear(vh) {
      var l = document.querySelectorAll('.bvf-assoc__actions');
      for (var i = 0; i < l.length; i++) {
        var a = l[i].getBoundingClientRect();
        if (a.height > 0 && a.bottom > 0 && a.top < vh + 200) return true;
      }
      return false;
    }
    function computeMode() {
      var b = findBtn();
      if (b) mainBtn = b;
      if (!mainBtn || !mainBtn.isConnected) return;
      var r = mainBtn.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var next;
      if (!r.width && !r.height) next = 'hidden';
      else if (r.bottom < 0 && !assocNear(vh)) next = 'add';
      else next = 'hidden';
      if (next !== mode) { mode = next; render(); }
    }
    var tick = null;
    function onMove() {
      if (tick) return;
      tick = setTimeout(function () { tick = null; computeMode(); }, 80);
    }
    window.addEventListener('scroll', onMove, { passive: true });
    window.addEventListener('resize', onMove);
    render();
    computeMode();

    var form = mainBtn.closest('product-form');
    if (form && window.MutationObserver) {
      new MutationObserver(debounce(function () {
        computeMode();
        if (pending && !busy()) { pending = false; if (adding() && !soldOut()) mainBtn.click(); }
        render();
      }, 80))
        .observe(form, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
    }
    if (mq.addEventListener) mq.addEventListener('change', render);
    refreshers.push(render);

    actionBtn.addEventListener('click', function () {
      if (adding()) {
        chosen = true;
        if (!mainBtn.disabled) mainBtn.click();
        else pending = true;
        render();
        return;
      }
      var target = document.querySelector('.rv5-flbl-fmt') || document.querySelector('variant-selects') || mainBtn;
      var top = target.getBoundingClientRect().top + window.pageYOffset - 96;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    });
  });

  /* ---------- 3. Panier : jauge de livraison offerte ---------- */
  safe(function () {
    if (!F.freeShip) return;
    var fs = CFG.freeShip || {};
    var threshold = Number(fs.threshold) || 0;
    if (threshold <= 0) return;
    var countries = String(fs.countries || '').toUpperCase().split(/[\s,;]+/).filter(Boolean);
    if (countries.length && countries.indexOf(String(CFG.country || '').toUpperCase()) === -1) return;
    var excluded = String(fs.exclude || '').toLowerCase().split(/[\s,;]+/).filter(Boolean);
    var tpl = document.getElementById('bvf-tpl-ship');
    if (!tpl || !tpl.content || !tpl.content.firstElementChild) return;
    var lastCart = null;

    function eligibleTotal(cart) {
      var total = 0;
      (cart.items || []).forEach(function (item) {
        if (item.requires_shipping === false) return;
        var handle = String(item.handle || '').toLowerCase();
        for (var i = 0; i < excluded.length; i++) { if (handle.indexOf(excluded[i]) !== -1) return; }
        total += (item.final_line_price != null ? item.final_line_price : item.line_price) || 0;
      });
      return total;
    }
    function slots() {
      var list = [];
      var header = document.querySelector('#CartDrawer .drawer__header');
      if (header) list.push({ anchor: header, after: true, page: false });
      if (CFG.template === 'cart') {
        var items = document.querySelector('cart-items') || document.getElementById('main-cart-items');
        if (items) list.push({ anchor: items, after: false, page: true });
      }
      return list;
    }
    function ensure() {
      slots().forEach(function (slot) {
        var parent = slot.anchor.parentNode;
        if (!parent) return;
        var existing = slot.page ? document.querySelector('[data-bvf="ship"].bvf-ship--page') : parent.querySelector(':scope > [data-bvf="ship"]');
        if (existing) return;
        var node = tpl.content.firstElementChild.cloneNode(true);
        if (slot.page) node.classList.add('bvf-ship--page', 'page-width');
        parent.insertBefore(node, slot.after ? slot.anchor.nextSibling : slot.anchor);
      });
    }
    function paint() {
      if (!lastCart) return;
      var eligible = eligibleTotal(lastCart);
      var left = threshold - eligible;
      var done = left <= 0;
      /* La jauge part déjà un peu remplie : « il reste un peu de chemin », pas tout le chemin */
      var head = Math.max(0, Math.min(40, Number(fs.head) || 0));
      var ratio = Math.max(0, Math.min(1, eligible / threshold));
      var pct = done ? 100 : Math.min(97, Math.round(head + (100 - head) * ratio));
      var msg = done ? (fs.done || '') : String(fs.todo || '').replace('[montant]', money(left));
      var parts = done ? [msg] : String(fs.todo || '').split('[montant]');
      document.querySelectorAll('[data-bvf="ship"]').forEach(function (node) {
        node.hidden = eligible <= 0;
        node.classList.toggle('is-done', done);
        var t = node.querySelector('[data-bvf-ship-text]');
        if (t && t.textContent !== msg) {
          /* Le montant restant en gras */
          t.textContent = '';
          parts.forEach(function (part, i) {
            if (i > 0) { var b = document.createElement('b'); b.textContent = money(left); t.appendChild(b); }
            if (part) t.appendChild(document.createTextNode(part));
          });
        }
        var fill = node.querySelector('[data-bvf-ship-fill]');
        if (fill) fill.style.width = pct + '%';
      });
    }
    function refresh() {
      var base = (window.routes && window.routes.cart_url) || '/cart';
      fetch(base + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) { if (cart) { lastCart = cart; ensure(); paint(); } })
        .catch(function () { /* silencieux */ });
    }
    var refreshSoon = debounce(refresh, 120);

    ensure();
    refresh();
    if (typeof window.subscribe === 'function') {
      try { window.subscribe((window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) || 'cart-update', function (ev) { var c = cartFromEvent(ev, lastCart); if (c) { lastCart = c; ensure(); paint(); } refreshSoon(); }); } catch (e) { /* bus absent */ }
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) {
      new MutationObserver(function () {
        if (!document.querySelector('#CartDrawer [data-bvf="ship"]')) { ensure(); paint(); refreshSoon(); }
      }).observe(drawer, { childList: true, subtree: true });
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('cart-drawer, cart-items')) refreshSoon();
    });
    refreshers.push(paint);
  });

  /* ---------- 3 bis. Panier : les paliers de lot, en haut ----------
     Sous la livraison offerte : « 2 tirages −10 % · 3 tirages −15 % … ». Le palier atteint est allumé,
     ceux d'avant cochés, les suivants en gris doux : des étapes à venir, pas des boutons cassés.
     Paliers lus dans le réglage (p2 à p5) ; affichés seulement si l'offre est en ligne ou en aperçu. */
  safe(function () {
    var OFFER = CFG.offer || {};
    if (!(OFFER.live || isPreview)) return;
    var tiers = [];
    [2, 3, 4, 5].forEach(function (k) { var p = Number(OFFER['p' + k]) || 0; if (p > 0) tiers.push({ n: k, pct: p }); });
    if (!tiers.length) return;
    var printType = String(CFG.printType || '');
    var T = CFG.lots || {};
    var lastCart = null;

    function el(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text != null) n.textContent = text;
      return n;
    }
    function prints(cart) {
      var n = 0, total = 0;
      (cart.items || []).forEach(function (it) {
        if (!isPrintType(it.product_type)) return;
        n += it.quantity || 0;
        total += (it.original_line_price != null ? it.original_line_price : it.line_price) || 0;
      });
      return { n: n, total: total };
    }
    function build(page) {
      var box = el('div', 'bvf-lots' + (page ? ' bvf-lots--page page-width' : ''));
      box.setAttribute('data-bvf', 'lots');
      box.hidden = true;
      box.appendChild(el('p', 'bvf-lots__say'));
      var list = el('ol', 'bvf-lots__steps');
      tiers.forEach(function (t) {
        var li = el('li', 'bvf-lots__step');
        li.setAttribute('data-n', t.n);
        li.appendChild(el('span', 'bvf-lots__pct', '−' + t.pct + (T.pct != null ? T.pct : ' %')));
        li.appendChild(el('span', 'bvf-lots__n', String(T.step || '[n] tirages').replace('[n]', t.n)));
        list.appendChild(li);
      });
      box.appendChild(list);
      if (!OFFER.live && OFFER.preview) box.appendChild(el('p', 'bvf-lots__note', OFFER.preview));
      return box;
    }
    /* Dans le tiroir : sous la livraison offerte (ou sous le titre). Sur la page : au-dessus des lignes. */
    function after(node, ref) { if (ref && ref.parentNode && ref.nextSibling !== node) ref.parentNode.insertBefore(node, ref.nextSibling); }
    function ensure() {
      var header = document.querySelector('#CartDrawer .drawer__header');
      if (header && header.parentNode) {
        var box = header.parentNode.querySelector(':scope > [data-bvf="lots"]') || build(false);
        after(box, header.parentNode.querySelector(':scope > [data-bvf="ship"]') || header);
      }
      if (CFG.template === 'cart') {
        var items = document.querySelector('cart-items') || document.getElementById('main-cart-items');
        var pbox = document.querySelector('.bvf-lots--page') || build(true);
        var pship = document.querySelector('[data-bvf="ship"].bvf-ship--page');
        if (pship) after(pbox, pship);
        else if (items && items.parentNode && pbox.nextSibling !== items) items.parentNode.insertBefore(pbox, items);
      }
    }
    function paint() {
      if (!lastCart) return;
      var p = prints(lastCart);
      var current = null, next = null;
      tiers.forEach(function (t) { if (p.n >= t.n) current = t; else if (!next) next = t; });
      var say;
      if (current) {
        say = String(T.on || '−[pct] % sur vos [n] tirages, soit [euros] de moins').replace('[pct]', current.pct).replace('[n]', p.n).replace('[euros]', money(p.total * current.pct / 100));
        if (next) say += String(T.more || ' · −[pct] % dès [k]').replace('[k]', next.n).replace('[pct]', next.pct);
      } else if (next) {
        say = String(T.first || 'Un tirage de plus : −[pct] % sur l\'ensemble').replace('[pct]', next.pct);
      }
      document.querySelectorAll('[data-bvf="lots"]').forEach(function (box) {
        box.hidden = isOff() || p.n < 1;
        var s = box.querySelector('.bvf-lots__say');
        if (s && s.textContent !== say) s.textContent = say || '';
        box.querySelectorAll('.bvf-lots__step').forEach(function (li) {
          var n = Number(li.getAttribute('data-n'));
          li.classList.toggle('is-on', !!current && n === current.n);
          li.classList.toggle('is-done', !!current && n < current.n);
          li.classList.toggle('is-next', !current || n > current.n);
        });
      });
    }
    function refresh() {
      var base = (window.routes && window.routes.cart_url) || '/cart';
      fetch(base + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) { if (cart) { lastCart = cart; ensure(); paint(); setTimeout(ensure, 700); } })
        .catch(function () { /* silencieux */ });
    }
    var refreshSoon = debounce(refresh, 140);
    ensure();
    refresh();
    if (typeof window.subscribe === 'function') {
      try { window.subscribe((window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) || 'cart-update', function (ev) { var c = cartFromEvent(ev, lastCart); if (c) { lastCart = c; ensure(); paint(); } refreshSoon(); }); } catch (e) { /* bus absent */ }
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) {
      new MutationObserver(function () {
        if (!document.querySelector('#CartDrawer [data-bvf="lots"]')) { ensure(); paint(); refreshSoon(); }
      }).observe(drawer, { childList: true, subtree: true });
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('cart-drawer, cart-items')) refreshSoon();
    });
    refreshers.push(paint);
  });

  /* ---------- 3 ter. Panier : liste d'envies et compte, puis « Tester sur un mur » si l'on hésite ----------
     Deux liens discrets sous le bouton de paiement (ou en bas du panier vide) : « Ma liste d'envies » et
     « Mon espace » (« Se connecter » sans compte ouvert). Le bouton « Tester ces tirages sur un mur »
     n'apparaît qu'après un moment passé dans le panier sans payer : sous les paliers, hors du pied,
     donc le bouton de paiement ne bouge pas. Une fois vu dans la session, il est là d'emblée. */
  safe(function () {
    var L = CFG.links || {};
    var W = CFG.wall || {};
    var printType = String(CFG.printType || '');
    function el(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text != null) n.textContent = text;
      return n;
    }
    var ICON_HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"><path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/></svg>';
    var ICON_USER = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><circle cx="12" cy="8.5" r="3.6"/><path d="M5 20c1.2-3.6 4-5.2 7-5.2s5.8 1.6 7 5.2"/></svg>';
    var ICON_WALL = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="6" width="7.5" height="10"/><rect x="13.5" y="8" width="7.5" height="6"/><path d="M2 20h20" stroke-linecap="round"/></svg>';
    function link(cls, href, icon, text) {
      var a = el('a', 'bvf-acces__link ' + cls);
      a.href = href;
      a.innerHTML = icon;
      a.appendChild(el('span', '', text));
      return a;
    }
    function buildAcces() {
      var row = el('p', 'bvf-acces');
      row.setAttribute('data-bvf', 'acces');
      row.appendChild(link('bvf-acces__wish', loc(L.wishlist || '/pages/wishlist?view=wishlist'), ICON_HEART, L.wishlistText || 'Mes coups de cœur'));
      if (CFG.loggedIn) row.appendChild(link('bvf-acces__account', L.account || '/account', ICON_USER, L.accountText || 'Mon espace'));
      else row.appendChild(link('bvf-acces__account', L.login || '/account/login', ICON_USER, L.loginText || 'Se connecter'));
      return row;
    }
    function placeAcces() {
      var ctas = document.querySelector('#CartDrawer .drawer__footer .cart__ctas');
      if (ctas && !ctas.parentNode.querySelector(':scope > [data-bvf="acces"]')) ctas.parentNode.insertBefore(buildAcces(), ctas.nextSibling);
      var empty = document.querySelector('#CartDrawer .cart-drawer__empty-content');
      if (empty && !empty.querySelector('[data-bvf="acces"]')) empty.appendChild(buildAcces());
      if (CFG.template === 'cart') {
        var pctas = document.querySelector('.cart__footer .cart__ctas');
        if (pctas && !pctas.parentNode.querySelector(':scope > [data-bvf="acces"]')) pctas.parentNode.insertBefore(buildAcces(), pctas.nextSibling);
        var pempty = document.querySelector('.cart__warnings');
        if (pempty && !pempty.querySelector('[data-bvf="acces"]')) pempty.appendChild(buildAcces());
      }
    }

    /* « Tester sur un mur » : les tirages du panier, dans Côte à côte */
    var DELAY = Math.max(5, Number(W.delay) || 25) * 1000;
    var url = null;
    var timer = null;
    var shown = storeGet('bvf_mur_vu', true) === '1';
    function wallUrl(cart) {
      var hs = [];
      (cart.items || []).forEach(function (it) {
        if (!isPrintType(it.product_type)) return;
        if (hs.indexOf(it.handle) === -1 && hs.length < 5) hs.push(it.handle);
      });
      if (!hs.length) return null;
      var base = loc(W.url || '/pages/framed-wall-planner');
      return base + (hs.length === 1 ? '?id=' + encodeURIComponent(hs[0]) : '?ids=' + hs.map(encodeURIComponent).join(','));
    }
    function buildWall(page) {
      var a = el('a', 'bvf-mur' + (page ? ' bvf-mur--page' : ''));
      a.setAttribute('data-bvf', 'mur');
      a.hidden = true;
      a.innerHTML = ICON_WALL;
      var t = el('span', 'bvf-mur__txt');
      t.appendChild(el('span', 'bvf-mur__q', W.ask || 'Un doute sur l\'accord ?'));
      t.appendChild(el('span', 'bvf-mur__go', W.text || 'Tester ces tirages sur un mur'));
      a.appendChild(t);
      if (!page) return a;
      /* Sur la page panier, le cadre garde les marges de la page */
      var wrap = el('div', 'bvf-mur-wrap page-width');
      wrap.appendChild(a);
      return wrap;
    }
    function placeWall() {
      var header = document.querySelector('#CartDrawer .drawer__header');
      if (header && header.parentNode && !header.parentNode.querySelector(':scope > [data-bvf="mur"]')) {
        var p = header.parentNode;
        var ref = p.querySelector(':scope > [data-bvf="lots"]') || p.querySelector(':scope > [data-bvf="ship"]') || header;
        p.insertBefore(buildWall(false), ref.nextSibling);
      }
      if (CFG.template === 'cart' && !document.querySelector('.bvf-mur--page')) {
        var items = document.querySelector('cart-items') || document.getElementById('main-cart-items');
        if (items && items.parentNode) items.parentNode.insertBefore(buildWall(true), items);
      }
    }
    function paintWall() {
      document.querySelectorAll('[data-bvf="mur"]').forEach(function (a) {
        if (url) a.href = url;
        var on = !!url && shown && !isOff();
        if (on && a.hidden) { a.hidden = false; requestAnimationFrame(function () { a.classList.add('is-in'); }); }
        if (!on) { a.hidden = true; a.classList.remove('is-in'); }
      });
    }
    function reveal() { shown = true; storeSet('bvf_mur_vu', '1', true); placeWall(); paintWall(); }
    function disarm() { clearTimeout(timer); timer = null; }
    /* Un compte à rebours déjà lancé continue : ajuster son panier, c'est encore hésiter */
    function arm() {
      if (timer || shown || !url) return;
      timer = setTimeout(function () { timer = null; if (document.visibilityState !== 'hidden') reveal(); else arm(); }, DELAY);
    }
    function refresh() {
      var base = (window.routes && window.routes.cart_url) || '/cart';
      fetch(base + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart) return;
          url = wallUrl(cart);
          placeAcces(); placeWall(); paintWall();
          var drawer = document.querySelector('cart-drawer');
          if (CFG.template === 'cart' || (drawer && drawer.classList.contains('active'))) arm();
        })
        .catch(function () { /* silencieux */ });
    }
    var refreshSoon = debounce(refresh, 160);
    placeAcces();
    refresh();
    if (typeof window.subscribe === 'function') {
      try { window.subscribe((window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) || 'cart-update', refreshSoon); } catch (e) { /* bus absent */ }
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) {
      /* Le tiroir s'ouvre (classe active) : le compte à rebours part ; il se ferme : il s'arrête */
      new MutationObserver(function (list) {
        list.forEach(function (m) {
          if (m.type === 'attributes' && m.target === drawer) { if (drawer.classList.contains('active')) arm(); else disarm(); }
        });
        if (!drawer.querySelector('[data-bvf="acces"]') || (url && !drawer.querySelector('[data-bvf="mur"]'))) { placeAcces(); placeWall(); paintWall(); }
      }).observe(drawer, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
    }
    /* Passer au paiement : on ne propose plus rien */
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('[name="checkout"], .cart__checkout-button')) disarm();
    }, true);
    refreshers.push(paintWall);
  });

  /* ---------- 5. Panier : un tirage compagnon ----------
     Avec un tirage au panier, le tiroir propose jusqu'à trois tirages dans le même format
     et la même finition, à ajouter en un geste. La remise duo / trio n'est affichée que si
     elle existe dans Shopify (case cochée) ou dans l'aperçu d'un thème non publié. */
  safe(function () {
    if (!F.cartDuo) return;
    var catEl = document.getElementById('bvf-catalog');
    if (!catEl) return;
    var CAT;
    try { CAT = JSON.parse(catEl.textContent); } catch (e) { return; }
    if (!CAT || !CAT.length) return;
    var byHandle = {};
    CAT.forEach(function (p) { byHandle[p.h] = p; });
    var T = CFG.cartDuo || {};
    var OFFER = CFG.offer || {};
    var offerOn = !!(OFFER.live || isPreview);
    var printType = String(CFG.printType || '');
    var MAX_PICKS = 3;
    var cache = {};

    /* Paliers p2 à p5, comme bisou-duo.js : un palier non réglé garde la remise du précédent. */
    function pctFor(n) {
      if (!offerOn) return 0;
      var best = 0;
      for (var k = 2; k <= Math.min(n, 5); k++) { var p = Number(OFFER['p' + k]) || 0; if (p) best = p; }
      return best;
    }
    function getProduct(handle) {
      if (cache[handle]) return cache[handle];
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      cache[handle] = fetch(base + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('produit ' + handle); return r.json(); });
      return cache[handle];
    }
    function sameOptions(a, b) {
      if (a.length !== b.length) return false;
      for (var i = 0; i < a.length; i++) if (String(a[i]).toLowerCase() !== String(b[i]).toLowerCase()) return false;
      return true;
    }
    function el(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text != null) n.textContent = text;
      return n;
    }
    /* Le CDN lit le premier width= d'une adresse : on retire celui qui y serait déjà avant d'ajouter le nôtre */
    function img(src, w) {
      if (!src) return '';
      if (src.indexOf('//') === 0) src = 'https:' + src;
      src = src.replace(/([?&])width=\d+&?/g, '$1').replace(/[?&]$/, '');
      return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
    }

    var block = el('div', 'bvf-cduo');
    block.setAttribute('data-bvf', 'cduo');
    block.hidden = true;
    var pageBlock = null;
    var sig = '';
    var picks = [];
    var base = null;
    var count = 0;
    var busy = false;

    function printLines(cart) {
      return (cart.items || []).filter(function (it) { return isPrintType(it.product_type); });
    }
    function signature(cart) {
      return printLines(cart).map(function (it) { return it.variant_id + 'x' + it.quantity; }).join('|');
    }

    /* Les compagnons : même orientation, disponibles dans le format et la finition du tirage au panier */
    function compute(cart) {
      var lines = printLines(cart);
      if (!lines.length) return Promise.resolve({ base: null, count: 0, picks: [] });
      var n = lines.reduce(function (s, it) { return s + (it.quantity || 0); }, 0);
      var first = lines[0];
      var info = byHandle[first.handle];
      var inCart = {};
      (cart.items || []).forEach(function (it) { inCart[it.handle] = true; });
      var options = (first.options_with_values || []).map(function (o) { return o.value; });
      var cands = CAT.filter(function (p) { return p.a && !inCart[p.h] && (!info || !info.o || p.o === info.o); }).slice(0, 10);
      var out = [];
      /* 27/10 (tiroir 11) : les candidats par lots de ce qui manque, en parallèle et dans l'ordre :
         le bloc arrive après un aller-retour au lieu de trois, pour le même nombre d'appels */
      function next(i) {
        if (out.length >= MAX_PICKS || i >= cands.length) return Promise.resolve(out);
        var lot = cands.slice(i, i + MAX_PICKS - out.length);
        return Promise.all(lot.map(function (c) {
          return getProduct(c.h).then(function (p) {
            var v = (p.variants || []).filter(function (x) { return x.available && sameOptions(x.options || [], options); })[0];
            return v ? { product: p, variant: v } : null;
          }).catch(function () { return null; /* produit indisponible */ });
        })).then(function (res) {
          res.forEach(function (r) { if (r && out.length < MAX_PICKS) out.push(r); });
          return next(i + lot.length);
        });
      }
      return next(0).then(function (list) { return { base: first, count: n, picks: list, options: options }; });
    }

    function render(target) {
      target.innerHTML = '';
      if (!base || count >= 5 || !picks.length) { target.hidden = true; return; }
      target.hidden = false;
      var head = el('div', 'bvf-cduo__head');
      var titles = [T.title2 || 'Un deuxième tirage ?', T.title3 || 'Et un troisième ?', T.title4 || 'Et un quatrième ?', T.title5 || 'Et un cinquième ?'];
      head.appendChild(el('p', 'bvf-cduo__title', titles[Math.min(Math.max(count, 1), 4) - 1]));
      var pct = pctFor(count + 1);
      /* 27/10 (langues) : le signe % du bloc de langue (collé en anglais et en japonais), comme les paliers du lot */
      if (pct) head.appendChild(el('span', 'bvf-cduo__pct', '−' + pct + ((CFG.lots || {}).pct != null ? CFG.lots.pct : ' %')));
      target.appendChild(head);
      target.appendChild(el('p', 'bvf-cduo__sub', String(T.sub || 'Même format et même finition que « [titre] »').replace('[titre]', base.product_title || '')));
      var list = el('div', 'bvf-cduo__list');
      picks.forEach(function (pk) {
        var row = el('div', 'bvf-cduo__item');
        var a = el('a', 'bvf-cduo__link');
        a.href = loc('/products/' + pk.product.handle + '?variant=' + pk.variant.id);
        var im = el('img', 'bvf-cduo__img');
        im.alt = '';
        im.loading = 'lazy';
        var fi = pk.variant.featured_image && pk.variant.featured_image.src;
        /* 27/10 (tiroir 11) : 200 px suffisent à l'ordinateur ; le téléphone (densité 2 à 3) prend 300, l'iPad 400 */
        var src0 = fi || pk.product.featured_image;
        if (src0) {
          im.sizes = '(min-width: 750px) 200px, 26vw';
          im.srcset = img(src0, 200) + ' 200w, ' + img(src0, 300) + ' 300w, ' + img(src0, 400) + ' 400w';
        }
        im.src = img(src0, 200);
        a.appendChild(im);
        var txt = el('span', 'bvf-cduo__txt');
        txt.appendChild(el('span', 'bvf-cduo__name', pk.product.title));
        txt.appendChild(el('span', 'bvf-cduo__price', money(pk.variant.price)));
        a.appendChild(txt);
        row.appendChild(a);
        var btn = el('button', 'bvf-cduo__add', T.add || 'Ajouter');
        btn.type = 'button';
        /* 27/10 (langues) : en japonais, le verbe vient après le titre (「Enfants Neige」を追加) */
        btn.setAttribute('aria-label', /^ja/.test(document.documentElement.lang || '') ? '「' + pk.product.title + '」を' + (T.add || '追加') : (T.add || 'Ajouter') + ' ' + pk.product.title);
        btn.addEventListener('click', function () { add(pk.variant.id, btn); });
        row.appendChild(btn);
        list.appendChild(row);
      });
      target.appendChild(list);
      if (pct) {
        var note = el('p', 'bvf-cduo__note', OFFER.live ? (OFFER.note || '') : (OFFER.preview || ''));
        note.classList.toggle('is-preview', !OFFER.live);
        if (note.textContent) target.appendChild(note);
      }
    }
    function renderAll() {
      render(block);
      if (pageBlock) render(pageBlock);
    }

    function add(variantId, btn) {
      if (busy) return;
      busy = true;
      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = T.added || 'Ajouté';
      var drawer = document.querySelector('cart-drawer');
      var body = { items: [{ id: variantId, quantity: 1 }] };
      if (drawer && typeof drawer.renderContents === 'function') {
        body.sections = ['cart-drawer', 'cart-icon-bubble'];
        body.sections_url = window.location.pathname;
      }
      var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
      fetch(url + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok || res.j.status) throw new Error('panier');
          if (typeof window.publish === 'function') {
            try { window.publish('cart-update', { source: 'bvf-cduo', cartData: res.j }); } catch (e) { /* bus absent */ }
          }
          if (drawer && res.j.sections && typeof drawer.renderContents === 'function') {
            drawer.renderContents(res.j);
          } else if (CFG.template === 'cart') {
            window.location.reload();
          }
        })
        .catch(function () { btn.disabled = false; btn.textContent = label; })
        .then(function () { busy = false; refresh(true); });
    }

    /* Un emplacement dans le tiroir (sous les lignes) et un sur la page panier */
    function place() {
      var items = document.querySelector('#CartDrawer cart-drawer-items');
      if (items && !items.contains(block)) items.appendChild(block);
      if (CFG.template === 'cart') {
        var ci = document.querySelector('cart-items') || document.getElementById('main-cart-items');
        if (ci && ci.parentNode && !pageBlock) {
          pageBlock = block.cloneNode(false);
          pageBlock.classList.add('bvf-cduo--page', 'page-width');
          ci.parentNode.insertBefore(pageBlock, ci.nextSibling);
        }
      }
    }

    var pending = false;
    function refresh(force) {
      if (pending) return;
      pending = true;
      var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
      fetch(cartUrl + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          pending = false;
          if (!cart) return;
          var s = signature(cart);
          place();
          if (!force && s === sig) { renderAll(); return; }
          sig = s;
          return compute(cart).then(function (res) {
            if (signature(cart) !== sig) return;
            base = res.base; count = res.count; picks = res.picks;
            renderAll();
          });
        })
        .catch(function () { pending = false; });
    }
    var refreshSoon = debounce(function () { refresh(false); }, 150);

    place();
    refresh(false);
    if (typeof window.subscribe === 'function') {
      try { window.subscribe((window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) || 'cart-update', function () { refresh(true); }); } catch (e) { /* bus absent */ }
    }
    var drawerEl = document.querySelector('cart-drawer');
    if (drawerEl && window.MutationObserver) {
      new MutationObserver(function () {
        if (!document.querySelector('#CartDrawer cart-drawer-items')) return;
        if (!block.isConnected) refreshSoon();
      }).observe(drawerEl, { childList: true, subtree: true });
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('cart-drawer, cart-items')) setTimeout(function () { refresh(true); }, 400);
    });
  });

  /* ---------- 8. Panier : des lignes plus claires ----------
     Le tiroir et la page panier du thème restent ceux de Dawn ; on range seulement chaque ligne :
     format et finition sur une ligne (sans « Format : … , »), l'artiste, « Retirer » en toutes lettres,
     le nombre de tirages près du titre, le total sans « EUR ». En « Avant », tout revient comme avant. */
  safe(function () {
    if (!F.cartTidy) return;
    var T = CFG.cartTidy || {};
    function el(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text != null) n.textContent = text;
      return n;
    }
    var printType = String(CFG.printType || '');
    var artists = {};
    var catEl = document.getElementById('bvf-catalog');
    if (catEl) {
      try { JSON.parse(catEl.textContent).forEach(function (p) { if (p.n) artists[p.h] = p.n; }); } catch (e) { /* pas d'artistes */ }
    }
    function handleOf(item) {
      var a = item.querySelector('.cart-item__name') || item.querySelector('a[href*="/products/"]');
      var m = a && (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      return m ? decodeURIComponent(m[1]) : '';
    }
    /* Tirage, carte cadeau ou autre article (t-shirt…) : pour compter juste et dessiner la carte cadeau. */
    var excl = String((CFG.freeShip || {}).exclude || '').toLowerCase().split(/[\s,;]+/).filter(Boolean);
    function kind(h) {
      h = String(h || '').toLowerCase();
      if (h === 'gift-card') return 'gift';
      for (var i = 0; i < excl.length; i++) { if (h.indexOf(excl[i]) !== -1) return 'other'; }
      return 'print';
    }
    /* La carte cadeau n'a pas d'image : une petite carte dessinée, comme sur sa fiche. */
    function giftThumb(item, h) {
      var media = item.querySelector('.cart-item__media');
      if (!media || media.querySelector('img, .bvf-gift')) return;
      var name = item.querySelector('.cart-item__name');
      var g = el('a', 'bvf-gift');
      g.href = (name && name.getAttribute('href')) || loc('/products/' + h);
      g.setAttribute('tabindex', '-1');
      g.setAttribute('aria-hidden', 'true');
      g.setAttribute('data-bvf', 'gift');
      var card = el('span', 'bvf-gift__card');
      card.appendChild(el('span', 'bvf-gift__eye', CFG.giftCard || 'Carte cadeau'));
      card.appendChild(el('span', 'bvf-gift__brand', 'Bisou Rivage'));
      g.appendChild(el('span', 'bvf-gift__glow'));
      g.appendChild(card);
      media.appendChild(g);
    }
    function tidyItem(item) {
      var details = item.querySelector('.cart-item__details');
      if (!details) return;
      var hk = handleOf(item);
      if (kind(hk) === 'gift') giftThumb(item, hk);
      var vals = [];
      details.querySelectorAll('dl .product-option dd').forEach(function (dd) {
        var v = (dd.textContent || '').replace(/\s+/g, ' ').replace(/[\s,]+$/, '').trim();
        if (v) vals.push(v);
      });
      var key = vals.join('|');
      var meta = details.querySelector(':scope > .bvf-line');
      if (meta && meta.getAttribute('data-k') === key) return;
      if (meta) meta.remove();
      meta = el('div', 'bvf-line');
      meta.setAttribute('data-bvf', 'line');
      meta.setAttribute('data-k', key);
      var h = handleOf(item);
      if (artists[h]) meta.appendChild(el('p', 'bvf-line__artist', artists[h]));
      if (vals.length) meta.appendChild(el('p', 'bvf-line__opts', vals.map(frameName).join(' · ')));
      var name = details.querySelector('.cart-item__name');
      if (name && name.parentNode === details) details.insertBefore(meta, name.nextSibling); else details.appendChild(meta);
      item.classList.add('bvf-tidy');
    }
    function tidyRemove(scope) {
      scope.querySelectorAll('cart-remove-button .button, cart-remove-button button, cart-remove-button a').forEach(function (b) {
        if (b.querySelector('.bvf-rm')) return;
        var t = el('span', 'bvf-rm', T.remove || 'Retirer');
        t.setAttribute('data-bvf', 'rm');
        b.appendChild(t);
        /* Le nom lu commence par le mot vu (« Retirer Abricot… », pas « Supprimer Abricot… ») : la commande vocale le trouve */
        var w = T.remove || 'Retirer', lab = b.getAttribute('aria-label') || '';
        /* 27/10 (langues) : en japonais, le verbe est à la fin (「…」を削除する → 「…」を外す) ; remplacer le premier mot mangeait le titre */
        if (/^ja/.test(document.documentElement.lang || '')) { if (lab && lab.slice(-w.length) !== w) b.setAttribute('aria-label', lab.replace(/削除する$/, w)); }
        else if (lab && lab.toLowerCase().indexOf(w.toLowerCase()) !== 0) b.setAttribute('aria-label', lab.replace(/^\S+/, w));
      });
    }
    function count(scope) {
      var c = { n: 0, print: 0, gift: 0, other: 0 };
      if (!scope) return c;
      scope.querySelectorAll('.cart-item').forEach(function (item) {
        var q = item.querySelector('input.quantity__input, input[name="updates[]"]');
        var n = q ? (parseInt(q.value, 10) || 0) : 1;
        c[kind(handleOf(item))] += n;
        c.n += n;
      });
      return c;
    }
    function heading() {
      var hd = document.querySelector('#CartDrawer .drawer__heading');
      if (!hd) return;
      var c = count(document.getElementById('CartDrawer'));
      /* « 2 tirages », ou « 1 tirage · 1 carte cadeau » quand il n'y a pas que des tirages */
      var parts = [];
      if (c.print) parts.push(c.print === 1 ? (T.one || '1 tirage') : String(T.many || '[n] tirages').replace('[n]', c.print));
      if (c.gift) parts.push(c.gift === 1 ? (T.gift1 || '1 carte cadeau') : String(T.giftN || '[n] cartes cadeaux').replace('[n]', c.gift));
      var other = !c.other ? '' : c.other === 1 ? (T.other1 || '1 article') : String(T.otherN || '[n] articles').replace('[n]', c.other);
      if (other) parts.push(other);
      var txt = parts.join(' · ');
      var span = hd.querySelector('.bvf-cart-n');
      if (!txt) { if (span) span.remove(); return; }
      if (!span) { span = el('span', 'bvf-cart-n'); span.setAttribute('data-bvf', 'cart-n'); hd.appendChild(span); }
      /* La part « autres articles », pour bisou-alt-plus.js (« 1 t-shirt ») : il la remplace sans relire de mots */
      if (span.getAttribute('data-bvf-other') !== other) span.setAttribute('data-bvf-other', other);
      if (span.textContent !== txt) span.textContent = txt;
    }
    function totals() {
      document.querySelectorAll('#CartDrawer .totals__total-value, .cart__footer .totals__total-value').forEach(function (n) {
        if (n.getAttribute('data-bvf-orig') == null) n.setAttribute('data-bvf-orig', n.textContent);
        var orig = n.getAttribute('data-bvf-orig');
        var want = isOff() ? orig : orig.replace(/\s*EUR\s*$/, '');
        /* Déjà à la française (« 95 € ») : sinon ce bloc et le bloc 6 se le reprenaient sans fin et le total tremblait */
        if (!isOff() && frPrice) want = frPrice(want);
        if (n.textContent !== want) n.textContent = want;
      });
    }
    var hosts = [document.querySelector('cart-drawer'), document.querySelector('cart-items'), document.getElementById('main-cart-footer')].filter(Boolean);
    function run() {
      document.querySelectorAll('#CartDrawer .cart-item, cart-items .cart-item').forEach(function (it) { safe(function () { tidyItem(it); }); });
      document.querySelectorAll('#CartDrawer, cart-items').forEach(function (sc) { tidyRemove(sc); });
      heading();
      totals();
      if (frWalk && !isOff()) hosts.forEach(function (h) { frWalk(h); });
    }
    run();
    if (window.MutationObserver) {
      /* Tout de suite, avant que la page se repeigne : la ligne et le total que Dawn vient d'écrire ne se montrent
         jamais bruts (une ligne se repliait puis se rallongeait, 25/10). Chaque étape ne réécrit que ce qui diffère. */
      hosts.forEach(function (h) { new MutationObserver(function () { safe(run); }).observe(h, { childList: true, subtree: true }); });
    }
    if (typeof window.subscribe === 'function') {
      try { window.subscribe((window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) || 'cart-update', function () { setTimeout(run, 60); }); } catch (e) { /* bus absent */ }
    }
    refreshers.push(totals);
  });

  /* ---------- 8 bis. Panier : changer de format et de finition sur place ----------
     Sous « A2 · Cadre noir », un bouton « Modifier » ouvre deux rangées : les formats (avec leur prix)
     et les finitions (pastille et nom). Un choix remplace la ligne par la bonne variante, même quantité ;
     le tiroir se redessine, les paliers et la livraison suivent. Rien d'autre ne change dans la ligne. */
  safe(function () {
    var TF = CFG.finish || {};
    var cache = {};
    var busy = false;
    var SW = { 'cadre noir': '#1b1b1b', 'cadre blanc': '#ffffff', 'cadre chêne': '#c49a6c', 'cadre bouleau': '#e8d6b4', 'sans cadre': 'transparent' };
    function el(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text != null) n.textContent = text;
      return n;
    }
    function getProduct(handle) {
      if (!cache[handle]) {
        cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error('produit'); return r.json(); });
      }
      return cache[handle];
    }
    function getCart() {
      var base = (window.routes && window.routes.cart_url) || '/cart';
      return fetch(base + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    }
    function lineIndex(item) {
      var q = item.querySelector('[data-index]');
      return q ? Number(q.getAttribute('data-index')) - 1 : -1;
    }
    function optIndex(product, re) {
      for (var i = 0; i < (product.options || []).length; i++) if (re.test(String(product.options[i].name || product.options[i]))) return i;
      return -1;
    }
    /* Page panier : un rechargement peut ressortir l'ancienne page (cache du navigateur, ou Shopify
       qui rend l'ancien panier quelques secondes). On relit la page sans cache jusqu'à ce qu'elle
       connaisse la nouvelle variante (5 s au plus), puis on remplace les lignes et le pied sur place. */
    function swapIn(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var done = 0;
      ['main-cart-items', 'main-cart-footer'].forEach(function (id) {
        var from = doc.getElementById(id), to = document.getElementById(id);
        if (from && to) { to.innerHTML = from.innerHTML; done++; }
      });
      return done === 2;
    }
    function reloadWhen(variantId, tries) {
      tries = tries || 0;
      if (tries >= 10) { window.location.reload(); return; }
      fetch(window.location.pathname + window.location.search, { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (html.indexOf('data-quantity-variant-id="' + variantId + '"') !== -1) {
            if (!swapIn(html)) { window.location.reload(); return; }
            /* Le pied relu a perdu nos liens (liste d'envies, compte) : nos blocs se reposent (relecture 23/10) */
            if (typeof window.publish === 'function') { try { window.publish('cart-update', { source: 'cart-items' }); } catch (e) { /* bus absent */ } }
          }
          else setTimeout(function () { reloadWhen(variantId, tries + 1); }, 500);
        })
        .catch(function () { window.location.reload(); });
    }
    function swap(line, variantId, cart) {
      if (busy || !line || variantId === line.variant_id) return Promise.resolve(false);
      busy = true;
      var updates = {};
      updates[line.key] = 0;
      var same = (cart.items || []).filter(function (it) { return it.variant_id === variantId; })[0];
      if (same) updates[same.key] = same.quantity + line.quantity; else updates[variantId] = line.quantity;
      var drawer = document.querySelector('cart-drawer');
      var body = { updates: updates };
      var inDrawer = drawer && drawer.classList.contains('active') && typeof drawer.renderContents === 'function';
      if (inDrawer) { body.sections = ['cart-drawer', 'cart-icon-bubble']; body.sections_url = window.location.pathname; }
      var url = (window.routes && window.routes.cart_update_url) || '/cart/update';
      return fetch(url + '.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok || res.j.status) throw new Error('panier');
          if (typeof window.publish === 'function') {
            /* source « cart-items » : les lignes du thème ne se redessinent pas une seconde fois
               (leur relecture pourrait ressortir l'ancien panier) ; nos blocs, eux, se mettent à jour */
            try { window.publish('cart-update', { source: 'cart-items', cartData: res.j }); } catch (e) { /* bus absent */ }
          }
          if (inDrawer && res.j.sections) drawer.renderContents(res.j);
          else reloadWhen(variantId);
          return true;
        })
        .catch(function () { /* la ligne reste telle quelle */ return false; })
        .then(function (ok) { busy = false; return ok; });
    }
    function panel(item, product, line, cart) {
      var fi = optIndex(product, /format|taille/i);
      var ni = optIndex(product, /finition|cadre/i);
      if (fi < 0 || ni < 0) return null;
      /* Les valeurs de la ligne par sa variante : en anglais, le panier les rend traduites, la fiche (.js) en français */
      var lv = (product.variants || []).filter(function (v) { return v.id === line.variant_id; })[0];
      var cur = lv ? lv.options : (line.options_with_values ? line.options_with_values.map(function (o) { return o.value; }) : []);
      var curF = cur[fi], curN = cur[ni];
      function variantFor(f, n) {
        return (product.variants || []).filter(function (v) { return v.options[fi] === f && v.options[ni] === n; })[0];
      }
      var box = el('div', 'bvf-fin');
      /* Un changement refusé (stock, réseau) : le panneau redevient touchable, la ligne n'a pas bougé */
      function unlock(ok) { if (!ok) box.classList.remove('is-busy'); }
      box.setAttribute('data-bvf', 'finish');
      var g1 = el('div', 'bvf-fin__group');
      g1.appendChild(el('p', 'bvf-fin__label', TF.format || 'Format'));
      var r1 = el('div', 'bvf-fin__row');
      product.options[fi].values.forEach(function (f) {
        var v = variantFor(f, curN);
        var b = el('button', 'bvf-fin__fmt' + (f === curF ? ' is-on' : ''));
        b.type = 'button';
        b.appendChild(el('span', 'bvf-fin__fmt-n', f));
        if (v) b.appendChild(el('span', 'bvf-fin__fmt-p', money(v.price)));
        b.disabled = !v || !v.available;
        b.setAttribute('aria-pressed', f === curF ? 'true' : 'false');
        b.addEventListener('click', function () { if (v && f !== curF) { box.classList.add('is-busy'); swap(line, v.id, cart).then(unlock); } });
        r1.appendChild(b);
      });
      g1.appendChild(r1);
      var g2 = el('div', 'bvf-fin__group');
      g2.appendChild(el('p', 'bvf-fin__label', TF.finish || 'Finition'));
      var r2 = el('div', 'bvf-fin__row bvf-fin__row--sw');
      product.options[ni].values.forEach(function (n) {
        var v = variantFor(curF, n);
        var b = el('button', 'bvf-fin__sw' + (n === curN ? ' is-on' : ''));
        b.type = 'button';
        var dot = el('span', 'bvf-fin__dot' + (/sans/i.test(n) ? ' is-none' : ''));
        dot.style.background = SW[String(n).toLowerCase()] || '#ccc';
        b.appendChild(dot);
        /* « Noir », « Sans cadre » : écrit comme sous la ligne (« A4 · Sans cadre »), pas « Sans Cadre » */
        var fn = frameName(n);
        var nm = fn !== n ? String(fn).replace(/\s+frame$/i, '') : String(n).replace(/^Cadre\s+/i, '');
        b.appendChild(el('span', 'bvf-fin__sw-n', nm.charAt(0).toUpperCase() + nm.slice(1).toLowerCase()));
        b.disabled = !v || !v.available;
        b.setAttribute('aria-pressed', n === curN ? 'true' : 'false');
        b.setAttribute('aria-label', fn + (v ? ' — ' + money(v.price) : ''));
        b.addEventListener('click', function () { if (v && n !== curN) { box.classList.add('is-busy'); swap(line, v.id, cart).then(unlock); } });
        r2.appendChild(b);
      });
      g2.appendChild(r2);
      box.appendChild(g1);
      box.appendChild(g2);
      return box;
    }
    /* Le panneau prend toute la largeur de la ligne : une rangée de tableau juste sous elle */
    function openRow(item) {
      var nx = item.nextElementSibling;
      return nx && nx.classList.contains('bvf-fin-tr') ? nx : null;
    }
    function toggle(item, btn) {
      var meta = item.querySelector('.bvf-line');
      var open = openRow(item);
      if (open) { open.remove(); btn.setAttribute('aria-expanded', 'false'); return; }
      var idx = lineIndex(item);
      var handle = (item.querySelector('.cart-item__name') && (item.querySelector('.cart-item__name').getAttribute('href') || '').match(/\/products\/([^/?#]+)/)) || null;
      if (!meta || idx < 0 || !handle) return;
      btn.setAttribute('aria-busy', 'true');
      Promise.all([getCart(), getProduct(decodeURIComponent(handle[1]))]).then(function (r) {
        var cart = r[0], product = r[1];
        var line = (cart.items || [])[idx];
        if (!line || line.product_id !== product.id) return;
        var box = panel(item, product, line, cart);
        if (!box) return;
        var tr = el('tr', 'bvf-fin-tr');
        var td = el('td', 'bvf-fin-td');
        td.colSpan = 4;
        td.appendChild(box);
        tr.appendChild(td);
        item.parentNode.insertBefore(tr, item.nextSibling);
        btn.setAttribute('aria-expanded', 'true');
      }).catch(function () { /* rien à proposer */ }).then(function () { btn.removeAttribute('aria-busy'); });
    }
    /* Seulement les tirages. La carte cadeau a elle aussi une option « Sans Cadre / Avec Cadre » (relecture 23/10) :
       on écarte par l'adresse du produit, comme le comptage du titre (gift-card et la liste d'exclusion). */
    var excl = String((CFG.freeShip || {}).exclude || '').toLowerCase().split(/[\s,;]+/).filter(Boolean);
    function isPrint(item) {
      var a = item.querySelector('.cart-item__name') || item.querySelector('a[href*="/products/"]');
      var m = a && (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      var h = m ? decodeURIComponent(m[1]).toLowerCase() : '';
      if (!h || h === 'gift-card') return false;
      for (var i = 0; i < excl.length; i++) { if (h.indexOf(excl[i]) !== -1) return false; }
      return true;
    }
    function decorate() {
      if (isOff()) return;
      document.querySelectorAll('#CartDrawer .cart-item.bvf-tidy, cart-items .cart-item.bvf-tidy').forEach(function (item) {
        var opts = item.querySelector('.bvf-line__opts');
        if (!opts || opts.querySelector('.bvf-fin__toggle')) return;
        /* Un tirage, dont la finition dit « cadre » (t-shirts, carte cadeau : rien) ; 27/10 (langues) : marco en espagnol, フレーム en japonais */
        if (!isPrint(item) || !/cadre|frame|marco|フレーム/i.test((opts.parentNode && opts.parentNode.getAttribute('data-k')) || opts.textContent || '')) return;
        var btn = el('button', 'bvf-fin__toggle', TF.edit || 'Modifier');
        btn.type = 'button';
        btn.setAttribute('aria-expanded', 'false');
        btn.addEventListener('click', function (e) { e.preventDefault(); toggle(item, btn); });
        opts.appendChild(btn);
      });
    }
    decorate();
    /* Tout de suite, comme le rangement des lignes (bloc 8) : « Modifier » arrive avec la ligne, qui ne grandit plus après (25/10) */
    [document.querySelector('cart-drawer'), document.querySelector('cart-items')].filter(Boolean).forEach(function (h) {
      if (window.MutationObserver) new MutationObserver(function () { safe(decorate); }).observe(h, { childList: true, subtree: true });
    });
  });

  /* ---------- 8 ter. Tiroir du panier : le clavier reste dedans, aussi sous Safari ----------
     Safari saute les liens au Tab : le piège de Dawn, qui attend le dernier lien du tiroir, laisse alors le focus
     passer à la page derrière, et Échap ne ferme plus rien. Tiroir ouvert : un focus arrivé dans la page revient au
     tiroir (au premier élément, ou au dernier avec Maj+Tab) ; Échap ferme le tiroir quand le focus n'est pas dedans. */
  safe(function () {
    var arriere = false;
    function ouvert() { var d = document.querySelector('cart-drawer'); return d && d.classList.contains('active') ? d : null; }
    function dehors(n, d) { return n && !d.contains(n) && !(n.closest && n.closest('dialog, [role="dialog"], [aria-modal="true"], [id^="shopify-pc__"]')); }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Tab') arriere = e.shiftKey;
      var d = ouvert();
      if (e.key === 'Escape' && d && typeof d.close === 'function' && (document.activeElement === document.body || dehors(document.activeElement, d))) d.close();
    });
    document.addEventListener('focusin', function (e) {
      var d = ouvert();
      if (!d || !dehors(e.target, d)) return;
      var f = [].filter.call(d.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'), function (n) { return n.getClientRects().length && getComputedStyle(n).visibility !== 'hidden'; });
      var t = arriere ? f[f.length - 1] : f[0];
      if (t) t.focus();
    });
  });

  /* ---------- 9. Carte cadeau sans image dans les grilles (recherche…) ----------
     La carte cadeau n'a pas d'image produit : là où le thème montre une vignette vide,
     on pose la carte dessinée (comme sur sa fiche). En « Avant », la vignette d'origine revient. */
  safe(function () {
    function draw() {
      document.querySelectorAll('.card-wrapper').forEach(function (w) {
        if (w.getAttribute('data-bvf-gift') === '1' || w.closest('.bca__cell--gift')) return;
        var a = w.querySelector('a[href*="/products/gift-card"]');
        var inner = w.querySelector('.card__inner');
        if (!a || !inner || inner.querySelector('img, .bvf-gift, .brv-gift')) return;
        var g = document.createElement('a');
        g.className = 'bvf-gift bvf-gift--tile';
        g.href = a.getAttribute('href');
        g.setAttribute('tabindex', '-1');
        g.setAttribute('aria-hidden', 'true');
        g.setAttribute('data-bvf', 'gift');
        var glow = document.createElement('span'); glow.className = 'bvf-gift__glow';
        var card = document.createElement('span'); card.className = 'bvf-gift__card';
        var eye = document.createElement('span'); eye.className = 'bvf-gift__eye'; eye.textContent = CFG.giftCard || 'Carte cadeau';
        var brand = document.createElement('span'); brand.className = 'bvf-gift__brand'; brand.textContent = 'Bisou Rivage';
        card.appendChild(eye); card.appendChild(brand);
        g.appendChild(glow); g.appendChild(card);
        w.setAttribute('data-bvf-gift', '1');
        w.classList.add('bvf-gift-host');
        inner.appendChild(g);
      });
    }
    draw();
    if (window.MutationObserver) {
      var t = null;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(draw, 150); }).observe(document.body, { childList: true, subtree: true });
    }
  });

  /* ---------- 7. Panier vide : trois tirages pour commencer ----------
     Sous « Continuer les achats », dans le tiroir comme sur la page panier :
     trois tirages (choisis par Liquid dans la collection réglée), puis les liens vers la grille et l'atlas. */
  safe(function () {
    if (!F.cartEmpty) return;
    var src = document.getElementById('bvf-empty-picks');
    if (!src) return;
    var picks;
    try { picks = JSON.parse(src.textContent); } catch (e) { return; }
    if (!picks || !picks.length) return;
    var T = CFG.cartEmpty || {};
    function el(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text != null) n.textContent = text;
      return n;
    }
    /* 28/10 (recherche 13) : dans le tiroir fermé, les photos attendent la fin du chargement de la page, l'ouverture du tiroir
       ou le doigt sur le panier, au premier des trois. Avant, leurs 3 fichiers partaient avec les photos de la page, pour un
       tiroir caché : le loading="lazy" ne suffit pas, le tiroir reste dans l'écran. */
    var drawerEl = document.querySelector('cart-drawer');
    var libre = false;
    function drawerOpen() { return !!(drawerEl && drawerEl.classList.contains('active')); }
    function reveal() {
      libre = true;
      if (!drawerEl) return;
      drawerEl.querySelectorAll('img[data-bvf-src]').forEach(function (im) { im.src = im.getAttribute('data-bvf-src'); im.removeAttribute('data-bvf-src'); });
    }
    function build(wait) {
      var box = el('div', 'bvf-empty');
      box.setAttribute('data-bvf', 'empty');
      /* Panier vide : la livraison offerte se dit déjà, avec son seuil.
         29/10 (c29-livraison-offerte-devise) : seulement dans les pays de la jauge (France) et en euros —
         au Japon, « dès ¥150 » passait le seuil de 150 € tel quel dans la devise. */
      var fs = CFG.freeShip || {};
      var shipPays = String(fs.countries || '').toUpperCase().split(/[\s,;]+/).filter(Boolean);
      var shipIci = (!shipPays.length || shipPays.indexOf(String(CFG.country || '').toUpperCase()) !== -1) && (CFG.currency || 'EUR') === 'EUR';
      if (F.freeShip && Number(fs.threshold) > 0 && shipIci) {
        /* 27/10 (audit-perfection-9) : « d’achat » (apostrophe courbe) */
        var shipP = el('p', 'bvf-empty__ship', String(fs.empty || 'Livraison offerte dès [seuil] d’achat').replace('[seuil]', money(Number(fs.threshold))));
        box.appendChild(shipP);
      }
      if (T.title) box.appendChild(el('p', 'bvf-empty__title', T.title));
      var list = el('div', 'bvf-empty__list');
      picks.forEach(function (p) {
        var a = el('a', 'bvf-empty__item');
        a.href = p.u;
        /* Le cadre posé sur son fond, avec de l'air autour : le gris ne touche plus le cadre */
        var wall = el('span', 'bvf-empty__wall');
        var im = el('img', 'bvf-empty__img');
        im.alt = ''; im.loading = 'lazy'; im.width = 180; im.height = 180;
        if (wait) im.setAttribute('data-bvf-src', p.i); else im.src = p.i;
        wall.appendChild(im);
        a.appendChild(wall);
        a.appendChild(el('span', 'bvf-empty__name', p.t));
        /* Audit perfection (25/10) : l'artiste comme un nom (« Max Winch »), sans « @ », comme sur les cartes */
        if (p.a) a.appendChild(el('span', 'bvf-empty__artist', String(p.a)));
        if (p.p) a.appendChild(el('span', 'bvf-empty__price', String(T.from || 'À partir de [prix]').replace('[prix]', money(p.p))));
        list.appendChild(a);
      });
      box.appendChild(list);
      var links = el('p', 'bvf-empty__links');
      if (T.all) { var l1 = el('a', 'bvf-empty__link', T.all); l1.href = loc(T.allUrl || '/collections/all'); links.appendChild(l1); }
      if (T.atlas) { var l2 = el('a', 'bvf-empty__link', T.atlas); l2.href = loc(T.atlasUrl || '/collections/all?view=carte'); links.appendChild(l2); }
      if (links.childNodes.length) box.appendChild(links);
      return box;
    }
    /* Juste après le bouton « Continuer les achats » du bloc vide */
    function placeIn(wrap, wait) {
      if (!wrap || wrap.querySelector('.bvf-empty')) return;
      var btn = wrap.querySelector('a.button');
      var box = build(wait);
      if (btn && btn.parentNode === wrap) wrap.insertBefore(box, btn.nextSibling); else wrap.appendChild(box);
    }
    function place() {
      placeIn(document.querySelector('#CartDrawer .cart-drawer__empty-content') || document.querySelector('#CartDrawer .drawer__inner-empty .cart-drawer__warnings'), !libre && !drawerOpen());
      if (CFG.template === 'cart') placeIn(document.querySelector('.cart__warnings'), false);
    }
    place();
    if (drawerEl && window.MutationObserver) {
      var soon = debounce(place, 120);
      new MutationObserver(function () { if (!drawerEl.querySelector('.bvf-empty')) soon(); }).observe(drawerEl, { childList: true, subtree: true });
      /* L'ouverture pose la classe « active » sur <cart-drawer> (cart-drawer.js) : les photos partent à ce moment */
      new MutationObserver(function () { if (drawerOpen()) reveal(); }).observe(drawerEl, { attributes: true, attributeFilter: ['class'] });
      /* Un temps d'avance : le doigt ou la souris arrive sur l'icône du panier */
      ['pointerdown', 'mouseover', 'focusin'].forEach(function (t) {
        document.addEventListener(t, function (e) { if (e.target && e.target.closest && e.target.closest('#cart-icon-bubble')) reveal(); }, { passive: true, capture: true });
      });
    }
    /* Sans geste : la page chargée et le navigateur au repos, le tiroir se garnit en silence (il s'ouvrira déjà plein) */
    var repos = function () { (window.requestIdleCallback || function (f) { setTimeout(f, 1200); })(reveal, { timeout: 4000 }); };
    if (document.readyState === 'complete') repos(); else window.addEventListener('load', repos, { once: true });
    if (typeof window.subscribe === 'function') {
      try { window.subscribe((window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) || 'cart-update', function () { setTimeout(place, 200); }); } catch (e) { /* bus absent */ }
    }
  });

  /* ---------- 6. Prix écrits à la française ----------
     La boutique écrit « €35,00 » (réglage de la devise) ; en français on écrit « 35 € ».
     Retouche d'affichage seulement : le vrai réglage est dans Paramètres > Général. */
  safe(function () {
    if (!F.prices || String(CFG.currency || 'EUR') !== 'EUR') return;
    /* « €35,00 », « €1.255,50 EUR », et « €35 » (carte cadeau) ; jamais un nombre collé à d'autres chiffres */
    var RE = /€\s?(\d{1,3}(?:[\s .]\d{3})*)(?:,(\d{2}))?(?!\d)(?!,\d)(?:\s?EUR)?/g;
    var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, NOSCRIPT: 1 };
    /* Le prix principal de la fiche (bloc #price-…) est relu par le script du thème, qui en
       compte les chiffres pour le bouton « Ajouter au panier » : on y garde les centimes
       (« 175,00 € »), sinon le bouton afficherait « 0 € ». */
    function keepsCents(el) { return !!(el && el.closest && el.closest('[id^="price-"]')); }
    function fix(s, cents) {
      return s.replace(RE, function (m, whole, c) {
        whole = whole.replace(/\./g, ' ');
        c = c || '00';
        return (cents || c !== '00' ? whole + ',' + c : whole) + ' €';
      });
    }
    var touched = [];
    function walk(node, cents) {
      if (!node) return;
      if (node.nodeType === 3) {
        var t = node.nodeValue;
        if (t && t.indexOf('€') !== -1) {
          /* 27/10 (audit-perfection-9) : un nœud texte arrivé par l'observateur passe ici sans ses parents ; « €150 » gardé sous data-bvf-keep. */
          if (node.parentElement && node.parentElement.closest('[data-bvf-keep]')) return;
          var f = fix(t, cents == null ? keepsCents(node.parentElement) : cents);
          if (f !== t) {
            if (node.bvfOrig == null) touched.push(node);
            node.bvfOrig = t;
            node.nodeValue = f;
          }
        }
        return;
      }
      if (node.nodeType !== 1 || SKIP[node.tagName] || node.hasAttribute('data-bvf-keep')) return;
      if (cents == null) cents = keepsCents(node);
      else if (!cents) {
        /* getAttribute : sur un <form>, « .id » peut renvoyer le champ nommé « id » */
        var id = node.getAttribute('id');
        if (id && id.indexOf('price-') === 0) cents = true;
      }
      for (var c = node.firstChild; c; c = c.nextSibling) walk(c, cents);
    }
    frPrice = function (s) { return fix(s, false); };
    frWalk = function (n) { walk(n); };
    function run() {
      if (isOff()) {
        /* Mode « avant » : on rend leur texte d'origine aux nœuds retouchés */
        touched.forEach(function (n) { if (n.isConnected && n.bvfOrig != null) n.nodeValue = n.bvfOrig; });
        return;
      }
      walk(document.body, false);
    }
    run();
    if (window.MutationObserver) {
      var timer = null;
      var queue = [];
      new MutationObserver(function (muts) {
        muts.forEach(function (m) {
          if (m.type === 'characterData') queue.push(m.target);
          else if (m.addedNodes) for (var i = 0; i < m.addedNodes.length; i++) queue.push(m.addedNodes[i]);
        });
        clearTimeout(timer);
        timer = setTimeout(function () {
          var q = queue; queue = [];
          if (isOff()) return;
          q.forEach(function (n) { if (n && n.isConnected) walk(n); });
        }, 60);
      }).observe(document.body, { childList: true, subtree: true, characterData: true });
    }
    refreshers.push(run);
  });

  /* ---------- 4. Invitation à rejoindre la communauté ---------- */
  safe(function () {
    var card = document.getElementById('bvf-nl');
    if (!card) return;
    document.body.appendChild(card); /* hors des sections : rien ne passe au-dessus */
    var viewForm = card.querySelector('[data-bvf-nl-view="form"]');
    var viewOk = card.querySelector('[data-bvf-nl-view="success"]');
    var mine = window.location.hash === '#bvf-nl-form';
    var posted = mine && /customer_posted=true/.test(window.location.search);
    var errored = mine && !posted && !!card.querySelector('[data-bvf-nl-error]');

    function open() {
      if (isOff()) return;
      card.hidden = false;
      setTimeout(function () { card.classList.add('is-open'); }, 30);
    }
    function close(remember) {
      card.classList.remove('is-open');
      setTimeout(function () { card.hidden = true; }, 320);
      if (remember) storeSet('bvf_nl_closed', String(Date.now()));
    }
    card.querySelector('[data-bvf-nl-close]').addEventListener('click', function () { close(true); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && card.classList.contains('is-open')) close(true); });
    refreshers.push(function () { if (isOff()) close(false); });

    if (posted) {
      storeSet('bvf_nl_done', '1');
      if (viewForm) viewForm.hidden = true;
      if (viewOk) viewOk.hidden = false;
      open();
      setTimeout(function () { close(false); }, 9000);
      return;
    }
    if (errored) { open(); return; }

    if (!F.newsletter || CFG.loggedIn) return;
    var tplName = String(CFG.template || '');
    var blocked = ['cart', 'password', 'gift_card', '404'];
    if (blocked.indexOf(tplName) !== -1 || tplName.indexOf('customers') === 0) return;
    if (CFG.suffix === 'vote' || CFG.pageHandle === 'vote') return;
    if (tplName === 'product' && !(CFG.nl && CFG.nl.onProduct)) return;
    if (storeGet('bvf_nl_done')) return;
    var closedAt = parseInt(storeGet('bvf_nl_closed') || '0', 10);
    var days = (CFG.nl && CFG.nl.days) || 21;
    if (closedAt && Date.now() - closedAt < days * 864e5) return;

    var delay = Math.max(5, (CFG.nl && CFG.nl.delay) || 20) * 1000;
    var start = Date.now();
    var fired = false;
    var retry = null;
    function busy() {
      var consent = document.getElementById('shopify-pc__banner');
      if (consent && consent.getClientRects().length) return true; /* bandeau en position fixe : offsetParent y est toujours nul */
      if (document.querySelector('cart-drawer.active, cart-drawer.animate.active, .menu-drawer-container[open], details[open] > .menu-drawer')) return true;
      /* 24/10 (menu et pied) : jamais par-dessus le menu ouvert, ni sur le pied de page,
         qui porte deja son propre formulaire « Rejoindre la communaute » */
      if (document.querySelector('#bisou-volet[aria-hidden="false"]')) return true;
      var foot = document.querySelector('.bisou-footer');
      if (foot && foot.getBoundingClientRect().top < window.innerHeight) return true;
      return false;
    }
    function fire() {
      if (fired) return;
      if (isOff() || busy()) {
        if (!retry) retry = setTimeout(function () { retry = null; fire(); }, 4000);
        return;
      }
      fired = true;
      cleanup();
      open();
    }
    function onScroll() {
      var h = document.documentElement;
      var ratio = (h.scrollTop + window.innerHeight) / Math.max(1, h.scrollHeight);
      if (ratio > 0.6 && Date.now() - start > delay / 2) fire();
    }
    var timer = setTimeout(fire, delay);
    window.addEventListener('scroll', onScroll, { passive: true });
    function cleanup() { clearTimeout(timer); window.removeEventListener('scroll', onScroll); }
  });
})();
